// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2wqW9","paramInput":"JobSimulator_paramInput__1aUT7","input":"JobSimulator_input__2M1rc"};